const MAX_QUERY_LENGTH = 100_000;

const DANGEROUS_KEYWORDS_PATTERN =
  /\b(DROP|DELETE\s+FROM|INSERT\s+INTO|UPDATE\s+\S+\s+SET|ALTER|TRUNCATE|CREATE|GRANT|REVOKE)\b/i;

const SYSTEM_TABLES_PATTERN = /\b(pg_catalog|information_schema|pg_user|stl_\w+|svl_\w+|svv_\w+)\b/i;

export function validateDownloadQuery(sql: string): void {
  if (!sql || typeof sql !== 'string') {
    throw new Error('Download query must be a non-empty string.');
  }

  if (sql.length > MAX_QUERY_LENGTH) {
    throw new Error(`Download query exceeds maximum allowed length of ${MAX_QUERY_LENGTH} characters.`);
  }

  const trimmedUpper = sql.trim().toUpperCase();

  if (!trimmedUpper.startsWith('SELECT') && !trimmedUpper.startsWith('WITH')) {
    throw new Error('Download query must be a SELECT statement. Only SELECT and WITH (CTE) queries are allowed.');
  }

  if (sql.includes(';')) {
    throw new Error('Download query must not contain semicolons. Only single statements are allowed.');
  }

  if (DANGEROUS_KEYWORDS_PATTERN.test(sql)) {
    throw new Error('Download query contains a disallowed SQL keyword. Only read-only queries are permitted.');
  }

  if (SYSTEM_TABLES_PATTERN.test(sql)) {
    throw new Error('Download query must not reference system catalog tables.');
  }
}
